import {createSvgIcon} from '../create-svg-icon';

export const SwitchRightIcon = createSvgIcon(
  <path d="M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z" />
, 'SwitchRightOutlined');
